import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]
  static values = { modalUrl: String }

  change(event) {
    const value = event.target.value

    if (value === "__add_new__") {
      event.target.value = ""

      const frame = document.getElementById("medical_role_modal")
      if (frame) {
        frame.src = this.modalUrlValue
      }
    }
  }
}
